// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\locations\\\\StudiosSection\\\\StudiosSection.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\locations\\StudiosSection\\StudiosSection.tsx");
  import.meta.hot.lastModified = "1759345537063.9927";
}
// REMIX HMR END

import { ImageGrid } from "~/components/shared/ImageGrid";
import { useNavigate } from "@remix-run/react";
export function StudiosSection({
  data
}) {
  _s();
  const navigate = useNavigate();
  console.log("StudiosSection data:", data);
  const items = data.studios.map(studio => ({
    id: studio.id,
    image: studio.image,
    title: studio.title,
    onClick: () => navigate(`/book-studio/${studio.id}`)
  }));
  return <section id="studios-section" className="relative w-full bg-white">
      <div className="mx-auto w-full py-14 lg:py-24">
        {/* <SectionHeader title={data.sectionTitle} className="mb-4 px-2 lg:px-6" /> */}
        <ImageGrid items={items} />
      </div>
    </section>;
}
_s(StudiosSection, "CzcTeTziyjMsSrAVmHuCCb6+Bfg=", false, function () {
  return [useNavigate];
});
_c = StudiosSection;
var _c;
$RefreshReg$(_c, "StudiosSection");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;